import React from 'react';
import PropTypes from 'prop-types';
import useIsMobile from 'tradera-hooks/use-is-mobile';
import ImageTag from './image-tag';
import './image-tags.scss';

const ImageTags = ({ gaAction, gaCategory, onClickTag, tags }) => {
    const limitTags = useIsMobile() ? 9 : 12;
    return (
        tags &&
        tags.length > 0 && (
            <div className="tags-container">
                {[...tags].splice(0, limitTags).map(tag => (
                    <ImageTag
                        gaCategory={gaCategory}
                        gaAction={gaAction}
                        key={tag.name}
                        imageUrl={tag.logoImageUrl}
                        name={tag.name}
                        onClick={() =>
                            typeof onClickTag === 'function' && onClickTag(tag)
                        }
                        url={tag.url}
                    />
                ))}
            </div>
        )
    );
};

ImageTags.propTypes = {
    gaAction: PropTypes.string.isRequired,
    gaCategory: PropTypes.string.isRequired,
    onClickTag: PropTypes.func,
    tags: PropTypes.array.isRequired
};

export default ImageTags;
